// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UsersTable_wrapper__1rsaa","footer":"UsersTable_footer__2qP_b"};